import { LOCALES } from "../constants";

export default {
    [LOCALES.FRENCH]: {
        "edit-file": "Modifiez {fichier} et enregistrez pour recharger.",
        "hello": "Bonjour",
    },
};
